import styles from 'styled-components';

const StyledHeading = styles.h5``;

const Heading5 = ({ children, ...rest }) => (
  <StyledHeading {...rest}>{children}</StyledHeading>
);

export default Heading5;
